import React, { useEffect, useState } from "react";
import "./ExerciseTest.css";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const ExerciseTest = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  // Validate Indian mobile number format
  const isValidMobile = (number) => /^[6-9]\d{9}$/.test(number);

  const startQuiz = async () => {
    if (mobile && name && isValidMobile(mobile)) {
      try {
        setLoading(true);
        const response = await fetch("https://api.codingveda.com/course/add_user", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ name, mobile })
        });

        const result = await response.json();
        setLoading(false);

        if (response.ok) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Thanks for login',
            showCloseButton: false,
            showConfirmButton: false,
            timer: 2000
          });

          localStorage.setItem("user", JSON.stringify({ name, mobile }));
          navigate("/Polices");
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: result.message || 'Something went wrong',
            showCloseButton: false,
            showConfirmButton: false,
            timer: 5000
          });
        }
      } catch (error) {
        setLoading(false);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Backend server error',
          showCloseButton: false,
          showConfirmButton: false,
          timer: 5000
        });
      }
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Enter valid name and 10-digit mobile number',
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container-fluid Form_background every_page_mg_top">
      <div className="row">
        <div className="col-md-6 mt-4 text-center">
          <img
            className="lottie_files w-100"
            style={{ maxWidth: "70vh" }}
            src="./images/exams.gif"
            alt="exam gif"
          />
        </div>
        <div className="col-md-6 text-center" style={{ backgroundColor: '#CDF7E4' }}>
          <h3 className="login_heading">Enter mobile number to start quiz</h3>
          <img src='./images/quiz_logo.png' className='img_main_login mt-4' alt="quiz logo" />

          <form onSubmit={(e) => e.preventDefault()} className="mt-4">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter name"
              required
            /><br/><br/>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter mobile number"
              required
              maxLength="10"
            />
          </form>

          <button onClick={startQuiz} className="login_btns mt-4" disabled={loading}>
            {loading ? "Starting..." : "Start Quiz"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExerciseTest;

